export const ENV_VARS_PROP_NAME = '__e_socna_env__';
